import { CheckboxState } from '../../../../../../components/checkboxV2/types/state';
import { CheckboxVariantType } from '../../variants';
import { commonStateStyles, disabledCommonStyles, errorCommonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [CheckboxVariantType.REGULAR]: {
            [CheckboxState.SELECTED]: {
                ...commonStateStyles(FOUNDATIONS, FONT, {}),
            },
            [CheckboxState.UNSELECTED]: {
                ...commonStateStyles(FOUNDATIONS, FONT, {}),
            },
            [CheckboxState.DISABLED_SELECTED]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT, {}),
            },
            [CheckboxState.DISABLED_UNSELECTED]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT, {
                    label: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                }),
            },
            [CheckboxState.ERROR_SELECTED]: {
                ...errorCommonStyles(FOUNDATIONS, FONT, {}),
            },
            [CheckboxState.ERROR_UNSELECTED]: {
                ...errorCommonStyles(FOUNDATIONS, FONT, {}),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map